package example.shadcn_kotlin.ui.pages.docs.components.hover_card

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.HoverCardDemo

@Page
@Composable
fun IndexPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/hover-card/index.md", mapOf("title" to listOf("Hover Card"), "description" to listOf("For sighted users to preview content available behind a link."), "component" to listOf("true"), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/hover-card"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/hover-card#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import lucide_react.CalendarDays
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h4
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import shadcn.ui.components.*
import web.cssom.ClassName

val HoverCardDemo = FC<Props> {
    HoverCard {
        HoverCardTrigger {
            asChild = true
            Button {
                variant = "link"
                + "@kobweb"
            }
        }
        HoverCardContent {
            className = ClassName("w-80")
            div {
                className = ClassName("flex justify-between space-x-4")
                Avatar {
                    AvatarImage {
                        src = "https://github.com/varabyte.png"
                    }
                    AvatarFallback{
                        +"VB"
                    }
                }
                div {
                    className = ClassName("space-y-1")
                    h4 {
                        className = ClassName("text-sm font-semibold")
                        +"@varabyte"
                    }
                    p {
                        className = ClassName("text-sm")
                        +"The Kobweb Framework – created and maintained by @varabyte."
                    }
                    div {
                        className = ClassName("flex items-center pt-2")
                        CalendarDays {
                            className = ClassName("mr-2 h-4 w-4 opacity-70")
                        }
                        +" "
                        span {
                            className = ClassName("text-xs text-muted-foreground")
                            +"Joined December 2021"
                        }
                    }
                }
            }
        }
    }
}
"""){ 
 HoverCardDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.HoverCard
import shadcn.ui.components.HoverCardContent
import shadcn.ui.components.HoverCardTrigger
""", lang= "kotlin", highlight= "")
            CodeBlock("""HoverCard {
    HoverCardTrigger { + "Hover" }
    HoverCardContent {
        + "The React Framework – created and maintained by @vercel."
    }
}
""", lang= "kotlin", highlight= "")
        }
    }
}
